const App = {
  DASHBOARD: "/",

  PROFILE_DEFAULT: "/profile/",
  PROFILE_ID: "/profile/:id",

  FULL_REPORT_DEFAULT: "/full-report",

  NURSES: "/nurses",
  ADD_NURSE: "/add-nurse/add",
  DEFAULT_EDIT_NURSE: "/edit-nurse/",
  EDIT_NURSE: "/edit-nurse/:id",

  REGISTRARS: "/registrars",
  ADD_REGISTRAR: "/add-registrar/add",
  DEFAULT_EDIT_REGISTRAR: "/edit-registrar/",
  EDIT_REGISTRAR: "/edit-registrar/:id",

  PATIENT_MATERIALS: "/patient-materials",

  VIEW_PATIENTS: "/view-patients",

  REPORT_EVENT: "/report-event",

  NOTIFICATIONS: "/notifications",

  PATIENT_INITIATION: "/patient-initiation",

  PRESCRIPTION_AUTHORISATION_FORM_DEFAULT: "/prescription-authorisation-form/",

  PRESCRIPTION_AUTHORISATION_FORM:
    "/prescription-authorisation-form/:userID/:pafID?",
  PRESCRIPTION_AUTHORISATION_FORM_DETAILS_DEFAULT:
    "/prescription-authorisation-form-details/",
  PRESCRIPTION_AUTHORISATION_FORM_DETAILS:
    "/prescription-authorisation-form-details/:pafID?",

  PAF_RENEW_DEFAULT: "/prescription-authorisation-form/renew/",
  PAF_RENEW:
    "/prescription-authorisation-form/renew/:typeOfPatient/:patientID/:lastPAFID?",
  RE_REGISTER: "/re-register",

  CONTACT_US: "/contact-us",
  ORDER_DEFAULT: "/order/",
  ORDER: "/order/:id",
  ORDER_EDIT_DEFAULT: "/order/edit/",
  ORDER_EDIT: "/order/edit/:pafID/:orderID",
};

const Auth = {
  LOGIN: "/login",
  REGISTER: "/register",
  VALIDATE_DEFAULT: "/validate",
  VALIDATE: "/validate/:uid/:token",
  RESET_PASSWORD: "/reset-password",
  RESET_PASSWORD_VALIDATE_DEFAULT: "/reset",
  RESET_PASSWORD_VALIDATE: "/reset/:nurse?/:uid/:token",
};

export { App, Auth };
